function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M1 9h7.535A3.998 3.998 0 0012 11v1a1 1 0 01-1 1H1a1 1 0 01-1-1v-2a1 1 0 011-1zm6.5 1h-5a.5.5 0 00-.09.992L2.5 11h5a.5.5 0 100-1zm5.77-5.456c.11 0 .216.04.299.112l2.262 1.967a.5.5 0 01.049.705l-.05.05-2.261 1.966A.456.456 0 0112.814 9v-.5a.5.5 0 00-.5-.5h-1.957a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h1.957a.5.5 0 00.5-.5V5c0-.252.204-.456.456-.456zM11 0a1 1 0 011 1v2a4 4 0 00-3.874 5H1a1 1 0 01-1-1V1a1 1 0 011-1h10zM6.5 4h-4a.5.5 0 00-.09.992L2.5 5h4a.5.5 0 000-1zm2-2h-6a.5.5 0 00-.09.992L2.5 3h6a.5.5 0 000-1z",
  fill: "#9BADBC",
  fillRule: "evenodd"
});

var SvgDestinationsIcon = function SvgDestinationsIcon(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13"
  }, props), _ref);
};

export default SvgDestinationsIcon;